import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem('wtf-wear-cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('wtf-wear-cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, variation, quantity = 1) => {
    setCart(currentCart => {
      const existingItem = currentCart.find(
        item => item.product.id === product.id &&
                item.variation?.id === variation?.id
      );

      if (existingItem) {
        return currentCart.map(item =>
          item.product.id === product.id && item.variation?.id === variation?.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }

      return [...currentCart, { product, variation, quantity }];
    });
  };

  const removeFromCart = (productId, variationId) => {
    setCart(currentCart =>
      currentCart.filter(
        item => !(item.product.id === productId && item.variation?.id === variationId)
      )
    );
  };

  const updateQuantity = (productId, variationId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId, variationId);
      return;
    }

    setCart(currentCart =>
      currentCart.map(item =>
        item.product.id === productId && item.variation?.id === variationId
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => {
      const price = item.variation?.price || item.product.price;
      return total + (price * item.quantity);
    }, 0);
  };

  const getCartCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartTotal,
        getCartCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
}
